/** Who a stored value belongs to, so it doesn't follow the user into another venue */
export interface StorageScope {
  companyId?: string
  userId?: string
}

const getStorageKey = (
  name: string,
  { companyId, userId }: StorageScope
): string => ['@@loaded', name, companyId, userId].filter(Boolean).join('/')

/** Falls back when nothing is stored yet, or when the value doesn't parse */
export const readStorageKey = <T>(
  name: string,
  scope: StorageScope,
  fallback: T
): T => {
  const stored = localStorage.getItem(getStorageKey(name, scope))
  if (stored === null) return fallback

  try {
    return JSON.parse(stored) as T
  } catch {
    return fallback
  }
}

export const writeStorageKey = <T>(
  name: string,
  scope: StorageScope,
  value: T
): void => {
  localStorage.setItem(getStorageKey(name, scope), JSON.stringify(value))
}
